// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ATFJm","toggleWrap":"styles_toggleWrap__UjOkm","content":"styles_content__AYsv2","selectAreaCode":"styles_selectAreaCode__19DOk"};